const COVER_DEFAULT_RATIO = '4 / 3';
const STORY_DEFAULT_RATIO = '3 / 2';

export const isCoverPage = (pageNum) => {
    const num = Number(pageNum);
    return num === 0 || num === 13;
};

const normalizeRatio = (ratio) => {
    if (!ratio || typeof ratio !== 'string') return null;
    const trimmed = ratio.trim();
    if (!trimmed) return null;

    if (trimmed.includes('/')) {
        return trimmed;
    }

    if (trimmed.includes(':')) {
        const parts = trimmed.split(':').map((p) => p.trim());
        if (parts.length === 2 && parts[0] && parts[1]) {
            return `${parts[0]} / ${parts[1]}`;
        }
    }

    return null;
};

export const resolveImageAspectRatio = (image, pageNum) => {
    const metadata = image?.metadata || {};

    if (metadata.width && metadata.height) {
        return `${metadata.width} / ${metadata.height}`;
    }

    const normalized = normalizeRatio(metadata.aspect_ratio);
    if (normalized) {
        return normalized;
    }

    return isCoverPage(pageNum) ? COVER_DEFAULT_RATIO : STORY_DEFAULT_RATIO;
};

export const getImageFrameStyle = (image, pageNum, options = {}) => {
    const {
        maxHeightCover = 520,
        maxHeightStory = 320,
        background = '#f8f9fa',
    } = options;

    return {
        width: '100%',
        maxHeight: isCoverPage(pageNum) ? `${maxHeightCover}px` : `${maxHeightStory}px`,
        aspectRatio: resolveImageAspectRatio(image, pageNum),
        borderRadius: '8px',
        background,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
};

export const getImageTagStyle = () => ({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
});
